import React from 'react';
import { Button } from 'react-bootstrap';
import { ImagePreview } from './ImagePreview';

function AddEditVerificationCell({ value, row }: any) {
  let currentYear = new Date().getFullYear().toString(); // TODO: Get this from the settings instead
  let rowData = {
    barCode: row.BarCode,
    assetNumber: row.AssetNumber,
    verifyId: row.VerifyId,
    year: row.Year,
    assetsViewId: row.AssetID,
    serialNumber: row.SerialNumber,
  };

  if (currentYear === row.Year) {
    if (value != null) {
      return(
        <Button 
          variant='primary'
          href={`/inventory/editVerification/verifyId=${rowData.verifyId}/${false}/false`}
        >
          <i className='fa fa-edit'/>
        </Button>
      )
      //return <EditVerificationModal data={rowData} disableFields={true} toTransfer={false} />;
    } else {
      let kType = (rowData.barCode && rowData.barCode !== '') ? 'b' : 'a'
      let data = encodeURIComponent(JSON.stringify({ barcode: rowData.barCode, assetNumber: String(rowData.assetNumber) }))
  
      return(
        <Button 
          variant='primary'
          href={`/inventory/create/${data}/${kType}`}
          >
          <i className='fa fa-plus'/>
        </Button>
      ) //<AddVerificationModal data={{barcode: rowData.barCode, assetNumber: rowData.assetNumber}} />;
    }
  } else {
    if (value != null) {
      return (
        <Button
          variant='primary'
          href={`/inventory/view/verifyId=${rowData.verifyId}`}>
            <i className='fa fa-eye'/>
        </Button>
      ) //<ViewVerificationModal data={rowData} />;
    } else return 'Oops';
  }
}

function imagePreview({value, row}: any){
  if(value !== null){
    return (
      <ImagePreview barcode={row.BarCode} year={row.Year}/>
    )
  }
  return '?'
}

export const columns = [
  {
    column: {
      Header: 'Add/Edit',
      accessor: 'VerifyId',
      resizable: true,
      filterable: false,
      Cell: AddEditVerificationCell,
      className: 'text-center',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Status',
      resizable: true,
      accessor: 'Status',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Barcode',
      resizable: true,
      accessor: 'BarCode',
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description',
      accessor: 'Description',
      resizable: true,
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description',
      accessor: 'Description2',
      resizable: true,
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Description',
      resizable: true,
      accessor: 'Description3',
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Serial #',
      accessor: 'SerialNumber',
      type: 'string',
      resizable: true,
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset Number',
      accessor: 'AssetNumber',
      resizable: true,
      // width: 400,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'Owner',
      resizable: true,
      accessor: 'Owner',
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Purchasing BU',
      accessor: 'OriginalPurchaser',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'PO Number',
      accessor: 'poNumber',
      resizable: true, 
      type: 'string'
    },
    type: 'string'
  },
  {
    column: {
      Header: 'Location',
      accessor: 'Location',
      resizable: true,
      width: 200,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Acquired',
      resizable: true,
      accessor: 'Acquired',
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Equip. Class',
      resizable: true,
      accessor: 'EquipmentClass',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Comments',
      accessor: 'AllComments',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Verify Date',
      resizable: true,
      accessor: 'VerifyDate',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Verified By',
      resizable: true,
      accessor: 'UserId',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Type of Verification',
      accessor: 'VerifyType',
      resizable: true,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Year',
      accessor: 'Year',
      resizable: true,
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Image?',
      accessor: 'BarCode',
      filterable: false,
      resizable: true,
      type: 'string',
      width: 50,
      Cell: imagePreview,
      className: 'text-center',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Department',
      resizable: true,
      accessor: 'Department',
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Capital Fund',
      resizable: true,
      accessor: 'CapitalSubDeptFund',
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Source',
      accessor: 'source',
      resizable: true,
      // width: 400,
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Inventoried',
      accessor: 'needScan',
      resizable: true,
      filterable: false,
      Cell: (props: any) => (props.value ? 0 || null : <i className='fas fa-check'></i>),
      type: 'string',
    },
    type: 'string',
  },
  {
    column: {
      Header: 'Asset ID',
      resizable: true,
      accessor: 'AssetID',
      // width: 400,
      type: 'number',
    },
    type: 'number',
  },
  {
    column: {
      Header: 'VerifyId',
      accessor: 'VerifyId',
      fitlerable: true,
      resizable: true,
      type: 'number',
    },
    type: 'number',
  },
];
